import { useMutation } from "@tanstack/react-query";
import React from "react";
import CustomCarrusel from "../custom-carrusel";
import { MessageResults } from "../messages-result";
import styled from "@emotion/styled";
import { getAgents } from "api/agent.request";
import AgentCollectionCardLight from "../agent-collection-card-light";

function SliderCollectionAgents() {
  const fetchProjectSlider = async (e: any) => {
    const response = await getAgents({ page: 1, collections: true });
    return response;
  };

  const { data, isLoading, isError, mutate } = useMutation(
    ["agents-slider"],
    fetchProjectSlider
  );

  React.useEffect(() => {
    mutate({});
  }, []);

  if (data! && data?.data?.length > 0 && isLoading) {
    return <MessageResults message="Sin Resultados" />;
  }

  if (isError) {
    return <MessageResults message="Ha ocurrido un error" />;
  }

  return (
    <>
      <section className="container">
        <CustomCarrusel>
          {data?.data.map((item: any, i) => (
            <Wrapper key={i}>
              <AgentCollectionCardLight
                picture={item.picture ?? "/icons/remax-logo-01.svg"}
                name={item.name}
                agencia={item.agency_name}
                id={item.id}
              />
            </Wrapper>
          ))}
        </CustomCarrusel>
      </section>
    </>
  );
}

export default SliderCollectionAgents;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 5px;
`;

const CollectionButton = styled.article`
  width: 100%;
  margin: auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;
